import { defineStore } from "pinia";

import { IConvertToPendingHosPal } from "./i-state";
import {
    SET_PATIENT_ID,
    SET_ACCOUNT_ID,
    SET_PATIENT_DETAILS,
    SET_APPLICATION,
    SET_COUNTRY_LIST,
    SET_PATIENT_REFERRAL_ID
} from "./types";
import { IHospiceConvertToPendingPatient } from "../../../../resources-vue/vue-interfaces/i-hospice-convertopending-patient";
import { HospiceConvertToPendingPatient } from "../../../../resources-vue/vue-models/hospice-convertToPending-details";

export const useHospiceConvertToPending = defineStore("convert-to-pending-hospal", {
    state: () =>
        ({
            patientId: "",
            accountId: "",
            application: "",
            patientDetails: new HospiceConvertToPendingPatient(),
            patientReferralId: "",
            countryList: null
        } as IConvertToPendingHosPal),
    actions: {
        [SET_PATIENT_ID](id: string | string[]) {
            this.patientId = id;
        },
        [SET_ACCOUNT_ID](id: string | string[]) {
            this.accountId = id;
        },
        [SET_PATIENT_DETAILS](payload: IHospiceConvertToPendingPatient) {
            this.patientDetails = payload;
        },
        [SET_APPLICATION](payload: string | string[]) {
            this.application = payload;
        },
        [SET_COUNTRY_LIST](payload: any) {
            this.countryList = payload;
        },
        [SET_PATIENT_REFERRAL_ID](payload: string | string[]) {
            this.patientReferralId = payload;
        }
    }
});
